import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Sub = styled.div`
  color: #717171;
  font-size: 14px;
`;

export default function Subline({
  locationLabel,
  guests,
  bedrooms,
  beds,
  bathrooms,
}) {
  const bits = [
    locationLabel,
    guests ? `${guests} guest${+guests > 1 ? "s" : ""}` : null,
    bedrooms ? `${bedrooms} bedroom${+bedrooms > 1 ? "s" : ""}` : null,
    beds ? `${beds} bed${+beds > 1 ? "s" : ""}` : null,
    bathrooms ? `${bathrooms} bathroom${+bathrooms > 1 ? "s" : ""}` : null,
  ].filter(Boolean);

  if (!bits.length) return null;
  return <Sub>{bits.join(" · ")}</Sub>;
}

Subline.propTypes = {
  locationLabel: PropTypes.string,
  guests: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bedrooms: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  beds: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bathrooms: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
